import React, { useState } from 'react';
import { Link } from 'react-scroll';
import './Navbar.css';

const Navbar = ({ appLogo, changeMenu }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <nav className={`navbar ${isMenuOpen ? 'open' : ''}`}>
            <div className="navbar-container">
                <div className="navbar-logo d-flex">
                    <img
                        className="logo-image"
                        src={appLogo}
                        height="50px"
                        width="50px"
                        alt="StudyAbroad Logo"
                        style={{
                            "object-fit": "contain",
                            "border-radius": "8px"
                        }}
                    />
                    <a className="logo-text" href="/">Study<sup style={{left:"-3px", top:"-10px", fontSize: "1.1rem"}}>Abroad</sup></a>
                </div>

                <div className={`navbar-links ${isMenuOpen ? 'active' : ''}`}>
                    <ul>
                        <li>
                            <Link
                            className='hover-pointer'
                                to="hero"
                                smooth={true}
                                duration={500}
                                spy={true}
                                offset={-60} // Adjust to avoid overlap with navbar
                            >
                                Home
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="features"
                                smooth={true}
                                duration={500}
                                spy={true}
                                offset={-60} // Adjust to avoid overlap with navbar
                            >
                                Features
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="universities"
                                smooth={true}
                                duration={500}
                                spy={true}
                                offset={-60} // Adjust to avoid overlap with navbar
                            >
                                University
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="about"
                                smooth={true}
                                duration={500}
                                spy={true}
                                offset={-60} // Adjust to avoid overlap with navbar
                            >
                                About
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="testimonials"
                                smooth={true}
                                duration={500}
                                spy={true}
                                offset={-60} // Adjust to avoid overlap with navbar
                            >
                                Testimonials
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="contact"
                                smooth={true}
                                duration={500}
                                spy={true}
                                offset={-60} // Adjust to avoid overlap with navbar
                            >
                                Contact
                            </Link>
                        </li>
                    </ul>
                </div>

                <div className="navbar-toggle" onClick={toggleMenu}>
                    <span className="bar"></span>
                    <span className="bar"></span>
                    <span className="bar"></span>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
